import { InjectSnippetRecord, SiteLocale } from '@graphql/generated';
import Script from 'next/script';
import config from '../../../data/config.json';

type Props = {
  locale: SiteLocale;
  data: InjectSnippetRecord;
};

const Snippet = ({ locale, data }: Props) => {
  const body = data._allBodyLocales.find((bodyLocale) => bodyLocale.locale === locale);
  if (!!body?.value) {
    switch (data.snippetType) {
      case 'css-head-link':
        return <link href={body.value} rel="stylesheet" />;
      case 'css-block':
        return <style dangerouslySetInnerHTML={{ __html: body.value }}></style>;
      case 'js-head-link':
        return (
          <Script
            id={data.id}
            src={body.value}
            {...(data.scriptParams as any)}
            strategy={
              data.scriptLoadStrategy as
                | 'afterInteractive'
                | 'lazyOnload'
                | 'beforeInteractive'
                | 'worker'
            }
            onError={(e) => {
              console.log('Script failed to load', e);
            }}
          />
        );
      case 'html-block':
        return <div dangerouslySetInnerHTML={{ __html: body.value }} />;
      case 'js-block':
        return (
          <Script
            id={data.friendlyName}
            {...(data.scriptParams as any)}
            strategy={
              data.scriptLoadStrategy as
                | 'afterInteractive'
                | 'lazyOnload'
                | 'beforeInteractive'
                | 'worker'
            }
            dangerouslySetInnerHTML={{ __html: body.value }}
            onError={(e) => {
              console.log('Script failed to load', e);
            }}
          />
        );
    }
  }
  return null;
};

export const Snippets = ({ locale }: { locale: SiteLocale }) => {
  return (
    <>
      {config.configuration?.snippets?.map((s) => (
        <Snippet key={s.id} data={s as InjectSnippetRecord} locale={locale} />
      ))}
    </>
  );
};
